import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { RangeKey } from '@dataTypes/dashboard.types'
import { isDashboardDevMocksEnabled } from '@utils/dashboardDevMocks.util'
import {
  hasNonZeroDashboardValues,
  isDashboardSectionPending,
} from '@utils/dashboardSectionEmpty.util'
import { getTaskCounts, type TaskCounts } from '../dashboardOverview.mockData'

const EMPTY_TASK_COUNTS: TaskCounts = {
  alerts: 0,
  checklist: 0,
  production: 0,
  scheduling: 0,
  followUps: 0,
  collections: 0,
  performance: 0,
}

type TasksCardProps = {
  range: RangeKey
}

export function TasksCard({ range }: TasksCardProps): React.ReactElement {
  const useMocks = isDashboardDevMocksEnabled()
  const taskCounts = useMocks ? getTaskCounts(range) : EMPTY_TASK_COUNTS
  const loading = false
  const isEmpty = !hasNonZeroDashboardValues(
    taskCounts.alerts,
    taskCounts.checklist,
    taskCounts.production,
    taskCounts.scheduling,
    taskCounts.followUps,
    taskCounts.collections,
    taskCounts.performance,
  )
  const pending = isDashboardSectionPending(loading, !isEmpty)
  const rows = [
    {
      label: 'Alerts',
      count: taskCounts.alerts,
      content: (
        <>
          <div>John Doe has hypertension. Proceed with care.</div>
          <div>
            Jane Smith has diabetes. Monitoring of blood sugar levels is
            essential.
          </div>
          <div>Mark Johnson has chronic migraines.</div>
        </>
      ),
    },
    {
      label: 'Checklist',
      count: taskCounts.checklist,
      content: <div>Content TBD</div>,
    },
    {
      label: 'Production',
      count: taskCounts.production,
      content: <div>Content TBD</div>,
    },
    {
      label: 'Scheduling',
      count: taskCounts.scheduling,
      content: <div>Content TBD</div>,
    },
    {
      label: 'Follow-ups',
      count: taskCounts.followUps,
      content: <div>Content TBD</div>,
    },
    {
      label: 'Collections',
      count: taskCounts.collections,
      content: <div>Content TBD</div>,
    },
    {
      label: 'Performance',
      count: taskCounts.performance,
      content: <div>Content TBD</div>,
    },
  ]

  return (
    <DashboardSectionCard
      title="Tasks"
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-alerts-list">
        {rows.map(({ label, count, content }) => (
          <details key={label}>
            <summary>
              <span className="alerts-row-label">{label}</span>
              <span className="alerts-row-count-pill">
                <span className="alerts-row-count">{count}</span>
              </span>
            </summary>
            <div className="alerts-row-content">{content}</div>
          </details>
        ))}
      </div>
    </DashboardSectionCard>
  )
}
